export default __webpack_public_path__ + "static/media/ClanOT-Book.9c288bee.ttf";